export default "__VITE_ASSET__cFWhSfhE__"